<div class="detail-ps">
  <div class="data-chart mb-6">
    <div
      class="d-flex flex-wrap justify-content-between align-items-center mb-3 ms-xxl-6 me-xxl-4"
    >
      <h1 class="fs-2 me-3 my-1">
        <ng-container
          *appSkeletonLoader="
            loading;
            style: { height: '2.5rem', width: '10rem' }
          "
        >
          <span i18n="@@patient_evaluationPS_title">Pain Scale (PS)</span>
        </ng-container>
      </h1>
      <form [formGroup]="dateRangeForm">
        <div class="data-chart__filter row align-items-center my-1">
          <div class="col-auto pe-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="startDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_fromLabel"
                >From</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '8rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownStartDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    type="text"
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18-placeholder="@@patient_evaluation_fromPlaceholder"
                    name="startDate"
                    formControlName="startDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownStartDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="calendar"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownStartDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'startDate');
                        dropdownStartDate.close()
                      "
                      [year]="getDateYear('startDate')"
                      [month]="getDateMonth('startDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-auto px-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="endDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_toLabel"
                >to</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '7rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownEndDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18-placeholder="@@patient_evaluation_toPlaceholder"
                    id="endDate"
                    formControlName="endDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownEndDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="calendar"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownEndDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'endDate');
                        dropdownEndDate.close()
                      "
                      [year]="getDateYear('endDate')"
                      [month]="getDateMonth('endDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </form>
    </div>
    <app-chart
      [loading]="loadingChart"
      [chartType]="'bar'"
      [chartDatasets]="datasets"
      [chartXLabels]="xLabels"
      [chartHorizontalLimitLines]="evaluation.horizontalLimitLines"
      [hasInteractiveLegend]="false"
    ></app-chart>
  </div>
  <div class="py-4 ms-xxl-6 me-xxl-4">
    <ngb-accordion #a="ngbAccordion" activeIds="desc_about, desc_situation">
      <ngb-panel id="desc_about">
        <ng-template ngbPanelHeader>
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_aboutTitle">About</span>
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loading;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_about')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loading; style: { height: '12rem' }"
            >
              <div i18n="@@patient_evaluationPS_aboutContent">
                <p>
                  Ce questionnaire permet d'évaluer l'intensité de la douleur
                  liée à la NMOSD, à l'aide d’une question.
                </p>
              </div>
              <div class="mt-4">
                <a
                  href="assets/documents/surveys/ps-{{ locale }}.png"
                  alt="ps"
                  target="_blank"
                >
                  <span
                    class="text-light fw-medium"
                    i18n="@@patient_evaluation_aboutSurveyFile"
                    >Show survey</span
                  ><span
                    class="link-icon d-inline-block p-3 rounded-3 bg-white me-3"
                  >
                    <img src="assets/img/icon-pdf.svg" class="img-fluid" />
                  </span>
                </a>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="desc_situation">
        <ng-template ngbPanelHeader let-opened="opened">
          <div
            class="d-flex align-items-center justify-content-between line-top"
          >
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_descriptionSituationTitle"
                  >Situation description</span
                >
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_situation')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loadingChart; style: { height: '12rem' }"
            >
              <div>
                <p i18n="@@patient_evaluationPS_situationDescriptionContentP1">
                  Les scores peuvent varier de 0 à 100, le score le plus élevé
                  indiquant des douleurs importantes.
                </p>
                <p class="mt-5">
                  <ng-container
                    i18n="@@questionnaires_patientStatusSummaryIntro"
                    >Entre le
                    <strong>
                      {{ dateRangeForm.get("startDate").value }}
                    </strong>
                    et le
                    <strong>
                      {{ dateRangeForm.get("endDate").value }}
                    </strong>
                    <strong>{{
                      patientProfile.firstName + " " + patientProfile.lastName
                        | uppercase
                    }}</strong>
                    a rempli
                    <strong> {{ measuringPointsTotal }} </strong>
                    questionnaires.
                  </ng-container>
                </p>
                <p class="mt-5">
                  <span
                    i18n="
                      @@patient_evaluationPS_situationDescriptionProgression1"
                    >Les résultats du questionnaire montrent que, durant cette
                    période, il y a eu une évolution de</span
                  >

                  <b> {{ progression }} </b>
                  <span
                    i18n="
                      @@patient_evaluationPS_situationDescriptionProgression2"
                    >de sa douleur liée à la NMOSD.</span
                  >
                </p>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
